import { initializeRecording } from "./initialize-recording";
export const startRecording = (args) => initializeRecording(args);
export default {};
